import * as React from 'react'
import { Column, Text, Row, Layout, Button, styleguide } from 'styleguide'
import HeroIllustration from './HeroIllustration'
import { css } from 'react-emotion'

export default function({ className, onCta }) {
  return (
    <Layout patterned size="hero">
      <Row
        justify="space-between"
        align="stretch"
        break
        css={`
          z-index: 2;
        `}>
        <Column
          justify="center"
          align="start"
          css={`
            z-index: 10;
          `}>
          <Text
            hero
            serif
            bold
            css={`
              margin-bottom: 20px;
              ${styleguide.mobile(
                css`
                  font-size: 4rem;
                  margin-top: 20px;
                `
              )};
            `}>
            Stop Guessing.
          </Text>
          <Text subtext pt>
            Know what your users are thinking & feeling, on site, when they make
            decisions.
          </Text>
          <div
            css={`
              margin-top: 40px;
              width: 100%;
              ${styleguide.mobile(
                css`
                  margin-top: 30px;
                `
              )};
            `}>
            <Button
              primary
              id="click-sign-up"
              onClick={() => onCta('click-sign-up')}>
              Sign Up For Updates
            </Button>
          </div>
        </Column>
        <HeroIllustration />
      </Row>
    </Layout>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/Hero/index.js